import { render, staticRenderFns } from "./PDFClientProtocol.vue?vue&type=template&id=035c3fb0&scoped=true&"
import script from "./PDFClientProtocol.vue?vue&type=script&lang=js&"
export * from "./PDFClientProtocol.vue?vue&type=script&lang=js&"
import style0 from "./PDFClientProtocol.vue?vue&type=style&index=0&id=035c3fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035c3fb0",
  null
  
)

export default component.exports